'use strict';

DoohApps
.directive('datePicker2', ['$parse', function ($parse) {
    return {
        restrict: 'A',
        scope: {
            defaultDate: '=',
            ngDisable: '=',
            onChange: '&',
            allday: '='
        },
        link: function (scope, element, attrs, controller) {
            //var date = moment(scope.defaultDate);
            var date;
            if (typeof scope.defaultDate == 'string') date = moment(scope.defaultDate);
            else date = moment([scope.defaultDate.getFullYear(), scope.defaultDate.getMonth(), scope.defaultDate.getDate()]);

            var day = date.format('DD');
            var month = date.format('MM');
            var year = date.format('YYYY');

            jQuery('#' + attrs.id).datetimepicker({
                defaultDate: year + '-' + month + '-' + day, timepicker: false, format: 'YYYY-MM-DD',
                onSelectDate: function (ct, $i) {
                    $i.datetimepicker('hide');
                    scope.$apply(function (scope) {
                        scope.defaultDate = ct;

                    });
                },
                onChangeDateTime: function (ct, $i) {
                    scope.$apply(function (scope) {
                        day = (ct.getDate() < 10) ? '0' + ct.getDate() : ct.getDate();
                        month = (ct.getMonth() < 9) ? '0' + (ct.getMonth() + 1) : (ct.getMonth() + 1);
                        year = ct.getFullYear();
                        scope.defaultDate = year + '-' + month + '-' + day;
                        //$('#' + id).val(scope.defaultDate)
                    });
                }
            });

            scope.$watch(function () { return scope.defaultDate }, function (newValue, oldValue) {
                if (!(typeof newValue == 'string' && typeof oldValue != 'string')) scope.onChange();
            });

        }
    }
}]);